import {Backend} from "@generated-backend-types";
import {ListItem} from '../entities/list-item.entity';
import MultilingualAttributeData = Backend.App.Data.Meta.MultilingualAttributeData;


export function sortListByGivenKey<Model extends BaseResource>(
  list: (ListItem & { model: Model })[],
  sortByKey: keyof Model | undefined,
): (ListItem & { model: Model })[] {

  function isMultilingualAttributeData(value: Model[keyof Model] | MultilingualAttributeData): value is MultilingualAttributeData {
    return typeof value === 'object' && value !== null &&  ('en' in Object.keys(value) && 'de' in Object.keys(value) && Object.keys(value).length === 2);
  }

  function compareValues(a: Model[keyof Model] | string | number | boolean | null, b: Model[keyof Model] |string | number | boolean | null): number {
    if (typeof a === 'string' && typeof b === 'string') {
      return a.localeCompare(b);
    }
    if (typeof a === 'number' && typeof b === 'number') {
      return a - b;
    }
    if (typeof a === 'boolean' && typeof b === 'boolean') {
      return Number(a) - Number(b);
    }
    return 0;
  }


  if (sortByKey) {
    return [...list].sort((a, b) => {
      const aValue: Model[keyof Model] = a.model[sortByKey];
      let finalAValue: Model[keyof Model] | string | number | boolean | null;

      if (isMultilingualAttributeData(aValue)) {
        finalAValue = aValue['de'];
      } else {
        finalAValue = aValue;
      }

      const bValue = b.model[sortByKey];
      let finalBValue: Model[keyof Model] | string | number | boolean | null;

      if (isMultilingualAttributeData(bValue)) {
        finalBValue = bValue['de'];
      } else {
        finalBValue = bValue;
      }

      return compareValues(finalAValue, finalBValue);
    });
  }
  return list;
}
